//@flow
import React from 'react'
import Spinner from './Spinner'

/**
 * Displays a spinner, optionally over the whole screen.
 * @memberof Module name.
 */
export default function LoadingComponent({
  children,
  style,
  fullscreen,
}: {
  children?: Array<React.Element<*>>,
  style?: Object,
  fullscreen?: boolean,
}) {
  const composedStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ...style,
  }
  if (fullscreen) {
    Object.assign(composedStyle, {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
    })
  }
  return (
    <div style={composedStyle}>
      <Spinner />
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js